import React from 'react';
import { Typography } from '@mui/material';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface SaveStateIndicatorProps {
  status: SaveStatus;
}

const SaveStateIndicator: React.FC<SaveStateIndicatorProps> = ({ status }) => {
  if (status === 'idle') return null;

  const label =
    status === 'saving' ? 'Saving…' :
    status === 'saved'  ? 'Saved'   :
    'Save failed — retrying';

  const color =
    status === 'saved'  ? 'success.main' :
    status === 'error'  ? 'error.main'   :
    'text.secondary';

  return (
    <Typography variant="caption" sx={{ color, fontStyle: 'italic', userSelect: 'none' }}>
      {label}
    </Typography>
  );
};

export default SaveStateIndicator;
